import { Vue } from "vue-class-component";
import { ElMessage } from "element-plus";
import { ServiceContext, ServiceFactory } from "../base/ServiceData";
import { BaseService } from "../service/BaseService";
import store from "@/store";
import { Success } from "../service/DataService";
import { Dict } from "@/script/apps/system/entity/SystemEntity";
import { DictService } from "@/script/apps/system/service/DictService";
import { DetailEntity } from "../base/IBaseEntity";
import bus from "@/script/core/util/Bus";
import { MenuData } from "../base/MenuData";

export abstract class BaseDetail extends Vue {
  public entity: any = {};

  public states: Dict[] = [];

  public types: Dict[] = [];

  public type = "A";

  public edit = false;

  public id = 0;

  public preRow: DetailEntity | null = null;

  public currRow: DetailEntity | null = null;

  public serviceContext: ServiceContext = ServiceFactory.build(
    "",
    "",
    "",
    new BaseService()
  );

  created() {
    // 业务元数据
    this.serviceContext = this.initData();
    this.serviceContext.entity = this.newEntity();
    if (this.serviceContext.entity) {
      this.entity = this.serviceContext.entity;
    }
    // 页面初始化后，强行刷新数据
    this.$route.query.cache = "0";
  }

  activated() {
    this.id = Number(this.$route.query.id);
    this.type = this.$route.query.type as string;
    const cache = this.$route.query.cache;
    // 可选项数据
    this.initOptions();
    if (cache === "0") {
      // 查看
      if (this.type === "V") {
        this.view();
      }
      // 修改
      if (this.type === "M") {
        this.modify();
      }
      // add
      if (this.type === "A") {
        this.add();
      }
    }
  }

  protected initOptions() {
    const dictService = new DictService();
    if (this.serviceContext.statesName) {
      dictService.loadChildItems(this.serviceContext.statesName, (data: any) => {
        this.states = data;
      });
    }
    if (this.serviceContext.typesName) {
      dictService.loadChildItems(this.serviceContext.typesName, (data: any) => {
        this.types = data;
      });
    }
  }

  public add() {
    this.entity = this.newEntity();
    if (this.serviceContext.statesName === "sys-state") {
      this.entity.state = "enable";
    }
    this.entity.creator = store.getters.loginUser.name;
    this.edit = true;
  }

  public view() {
    this.beforeLoad();
    this.load(this.id, (data: any) => {
      this.entity.modifier = store.getters.loginUser.name;
    });
    const menuData: MenuData = {
      name: String(this.serviceContext.listUrl),
      path: String(this.serviceContext.detailUrl),
      query: { id: this.id, type: "V", cache: "1" },
      isClose: true
    };
    bus.emit("to-detail", menuData);
    this.edit = false;
  }

  public modify() {
    this.beforeLoad();
    this.load(this.id, (data: any) => {
      this.entity.modifier = store.getters.loginUser.name;
    });
    const menuData: MenuData = {
      name: String(this.serviceContext.listUrl),
      path: String(this.serviceContext.detailUrl),
      query: { id: this.id, type: "M", cache: "1" },
      isClose: true
    };
    bus.emit("to-detail", menuData);
    this.edit = true;
  }

  public load(id: number, success?: Success) {
    const self = this;
    this.serviceContext.service.loadEntity(
      this.serviceContext.serviceData.loadApiName,
      {
        id
      },
      function (data: any) {
        self.entity = data;
        self.afterLoad(self.entity);
        if (success) {
          success(data);
        }
      },
      function (error: Error) {
        ElMessage.error("加载数据失败，失败原因：" + error.message);
      }
    );
  }

  public goBack() {
    this.$router.push({ path: this.serviceContext.listUrl });

    const menuData: MenuData = {
      name: String(this.serviceContext.listUrl),
      path: String(this.serviceContext.listUrl),
      isClose: true
    };
    bus.emit("goback-list", menuData);
  }

  public save() {
    const self = this;
    (this.$refs.mainForm as any).validate((valid: boolean) => {
      if (valid) {
        if (!self.beforeSave()) {
          return;
        }
        self.serviceContext.service.saveEntity(
          self.serviceContext.serviceData.saveApiName,
          self.entity,
          function (data: any) {
            self.id = data.id;
            self.entity.id = data.id;
            ElMessage({ type: "success", message: "保存成功!" });
            self.afterSave();
            self.load(self.id);
          },
          function (error: Error) {
            ElMessage.error("保存失败，原因：" + error.message);
          }
        );
      } else {
        return false;
      }
    });
  }

  public reset() {
    if (this.id !== 0) {
      this.load(this.id);
    }
  }

  public rowList: DetailEntity[] | null = [];
  public deleteRowList: DetailEntity[] = [];

  protected injectDetailData(
    rowList: DetailEntity[],
    deleteRowList: DetailEntity[]
  ) {
    this.rowList = rowList;
    this.deleteRowList = deleteRowList;
  }

  public addRow() {
    this.addListRow(this.rowList!);
  }

  addListRow(rowList: DetailEntity[]): void;
  addListRow(rowList: DetailEntity[], rowData?: DetailEntity): void;
  public addListRow(rowList: DetailEntity[], rowData?: DetailEntity) {
    if (!rowData) {
      rowData = {};
    }
    rowData.flag = "A";
    rowData.no = rowList.length + 1;
    rowData.edit = true;
    rowList.push(rowData);
    this.setRowEdit(rowData);
  }

  public deleteRow(scope: any) {
    this.deleteListRow(scope, this.rowList!, this.deleteRowList);
  }

  public deleteListRow(scope: any, rowList: DetailEntity[], deleteRowList: DetailEntity[]) {
    rowList.splice(scope.$index, 1);
    const rowData = scope.row as DetailEntity;
    if (rowData.flag === "M" || rowData.flag === "N") {
      rowData.flag = "D";
      deleteRowList.push(rowData);
    }
  }

  public modifyRow(rowData: DetailEntity) {
    rowData.edit = true;
    if (rowData.flag === "N") {
      rowData.flag = "M";
    }
  }

  public generateRowNo() {
    this.generateListRowNo(this.rowList!);
  }

  public generateListRowNo(rowList: DetailEntity[]) {
    if (rowList) {
      let no = 1;
      rowList!.forEach(item => {
        item.no = no++;
      });
    }
  }

  public rowClick(row: any, column: any, event: any) {
    this.modifyRow(row);
    this.setRowEdit(row);
  }

  private setRowEdit(row: DetailEntity) {
    if (this.currRow) {
      this.preRow = this.currRow;
      this.preRow.edit = false;
    }
    this.currRow = row;
    this.currRow!.edit = true;
  }

  public abstract initData(): ServiceContext;
  public abstract newEntity(): any;
  public beforeLoad() { }
  public afterLoad(data: any) { }

  public beforeSave(): boolean {
    return true;
  }

  public afterSave() { }
}
